import { useQuery } from "@tanstack/react-query";
import { StrapiResponse } from "~/shared-types";
import { strapiClient } from "~/strapi/api";

export const SINGLE_PAGE_QUERY_KEY = "singlePage";

const getSinglePage = async <TReturn>(endpoint: string) => {
  const { data } = await strapiClient.get<StrapiResponse<TReturn>>(
    `/${endpoint}?populate=*`
  );

  return data.data;
};

export const useSinglePageQuery = <TReturn>(endpoint: string) => {
  return useQuery({
    queryKey: [SINGLE_PAGE_QUERY_KEY, endpoint],
    queryFn: () => getSinglePage<TReturn>(endpoint),
  });
};
